import { useApp } from '../../context/AppContext';
import { Button } from '../ui/button';
import { Banknote } from 'lucide-react';

export const CurrencyToggle = () => {
  const { currency, toggleCurrency } = useApp();
  
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleCurrency}
      className="h-9 px-3 rounded-full hover:bg-muted transition-all duration-200 gap-2"
      data-testid="currency-toggle"
    >
      <Banknote className="h-4 w-4 text-muted-foreground" />
      <span className="font-medium text-sm">
        {currency}
      </span>
    </Button>
  );
};

export default CurrencyToggle;
